import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
// import { base64logo, base64watermark } from "./BaseImages";

// import { useEffect, useState } from "react";
Font.register({
  family: "Roboto",
  fonts: [
    { src: "http://fonts.gstatic.com/s/roboto/v15/W5F8_SL0XFawnjxHGsZjJA.ttf" },
    {
      src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
      fontStyle: "normal",
      fontWeight: 700,
    },
  ],
});

// Definir los estilos
const styles = StyleSheet.create({
  page: {
    fontSize: 12,
    color: "#454546",
    height: "100%",
  },
  header: {
    paddingHorizontal: 40,
    paddingTop: 40,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },

  logo: {
    width: "auto",
    height: 64, // Reduce from 64 to 50
  },

  // Update the headerright style
  headerright: {
    width: "auto",
    height: 45, // Reduce from 25% to 10%
  },
  headerright: {
    width: "auto",
    height: "25%", // Último valor definido
  },
  title: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "Roboto",
    color: "#000",
    marginBottom: 20,
  },
  section: {
    paddingHorizontal: 40,
    marginBottom: 10,
  },
  textBold: {
    color: "#000",
    fontSize: 12,
    fontFamily: "Roboto",
  },
  text: {
    marginBottom: 5,
    fontSize: 12,
    fontFamily: "Roboto",
  },
  footerImage: {
    width: "100%",
    height: "8%",
    position: "absolute",
    bottom: 0,
  },
  watermark: {
    position: "absolute",
    top: "35%",
    left: "15%",
    width: "70%",
    opacity: 0.04,
    zIndex: "-10",
  },
  information: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    marginBottom: 10,
  },

  table: {
    display: "table",
    width: "auto",
    margin: 10,
  },

  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: 35,
    padding: 2,
    borderBottom: "1px solid #eee",
  },

  cell: {
    flex: 1,
    padding: "5px 5px",
    textAlign: "center",
    fontSize: "10px",
    minWidth: "20%",
    maxWidth: "25%",
    wordWrap: "break-word",
    overflow: "hidden",
  },

  striped: {
    backgroundColor: "#e0e0e0",
  },

  headerTable: {
    backgroundColor: "#f0f0f0",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },

  horizontalLine: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
  },

  firmas: {
    marginTop: 40,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 20,
    position: "absolute",
    bottom: 20,
  },
  colum: {
    flex: 1,
    marginRight: 20,
    textAlign: "center",
    paddingTop: 80,
  },
  columDr: {
    flex: 1,
    textAlign: "center",
    marginLeft: 20,
  },
  firma: {
    width: "50%",
    marginLeft: "25%",
    height: "45%",
  },
});

const PaymentsMorlessPdf = ({ data }) => {
  return (
    <Document>
      <Page style={styles.page}>
        <Image
          fixed
          style={styles.watermark}
          src="/images/logomolarcorazomariaeugenia_mareug.PNG"
        />
        {/* Header */}
        <View fixed style={styles.header}>
          <Image
            style={styles.logo}
            src="/images/logomolarcorazon_mareug_header_izquierdo.PNG"
          />
          <Image
            style={styles.headerright}
            src="/images/headerright_eugenia.png"
          />
        </View>
        {/* Title */}
        <Text style={styles.title}>PAGOS MOROSOS</Text>
        {/* Patient Information */}
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>
                {process.env.REACT_APP_NOMBRE_DOC}
              </Text>
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Lugar de atención:</Text> Clinica
              Integral Norte
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Fecha:</Text>{" "}
              {new Date().toLocaleDateString("es-ES")}
            </Text>
          </View>
        </View>

        {/* Odontograma Details */}

        <View style={styles.table}>
          {/* Fila de encabezado */}
          <View style={[styles.row, styles.headerTable]}>
            <Text style={styles.cell}>#</Text>
            <Text style={styles.cell}>Nombre</Text>
            <Text style={styles.cell}>Saldo</Text>
            <Text style={styles.cell}>Monto</Text>
            <Text style={styles.cell}>Fecha</Text>
          </View>
          <View style={styles.horizontalLine} />
          {/* Fila de datos */}
          <>
            {data.map((patient, index) => (
              <>
                {patient?.saldo > 0 && (
                  <>
                    <View
                      key={index}
                      style={[
                        styles.row,
                        styles.headerTable,
                        index % 2 === 0 ? {} : styles.striped,
                      ]}
                    >
                      <Text style={styles.cell}>{index + 1}</Text>
                      <Text style={styles.cell}>
                        {patient?.patient?.persona?.nombre +
                          " " +
                          patient?.patient?.persona?.apellidos}
                      </Text>

                      <Text style={styles.cell}>{patient?.saldo}</Text>

                      <Text style={styles.cell}>{patient?.monto}</Text>

                      <Text style={styles.cell}>
                        {new Date(patient?.created_at).toLocaleDateString(
                          "es-ES"
                        )}
                      </Text>
                    </View>
                    <View style={styles.horizontalLine} />
                  </>
                )}
              </>
            ))}
          </>
        </View>

        {/* Firmas */}
      </Page>
    </Document>
  );
};

export default PaymentsMorlessPdf;
